import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useRef } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { AnimatedGrid } from '../AnimatedSection';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import getLocal from 'eco-design-reliance/getLocal';


const Built: React.FC = () => {
    const { t } = useLang('Built');
    const swiperRef = useRef<any>(null);
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)
    const imgsH5: { [key: string]: string } = {
        eu: 'https://websiteoss.ecoflow.com/upload/image/1774248297738/EU.jpg',
        uk: 'https://websiteoss.ecoflow.com/upload/image/1774406816899/UK%20(1).jpg',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1774322259689/FR.jpg',
        nl: 'https://websiteoss.ecoflow.com/upload/image/1774248298711/NL.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1774248297217/DE.jpg',
        it: 'https://websiteoss.ecoflow.com/upload/image/1774248298446/IT.jpg',
        es: 'https://websiteoss.ecoflow.com/upload/image/1774248297406/ES.jpg',
    }
    const imgs: { [key: string]: string } = {
        eu: 'https://websiteoss.ecoflow.com/upload/image/1773998478063/EU.jpg',
        uk: 'https://websiteoss.ecoflow.com/upload/image/1774406817022/UK.jpg',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1774322259540/FR%20(1).jpg',
        nl: 'https://websiteoss.ecoflow.com/upload/image/1773998478626/NL.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1773998477641/DE.jpg',
        it: 'https://websiteoss.ecoflow.com/upload/image/1773998478440/IT.jpg',
        es: 'https://websiteoss.ecoflow.com/upload/image/1773998477827/ES.jpg',
    }
    const list = [
        {
            title: t('list1_title'),
            desc: t.rich('list1_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774321998169/Frame%201000009369.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774321998169/Frame%201000009369.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1757756429435-cqlafb-compressed-%E8%8A%AF%E7%89%87.jpg',
            pad: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774321998169/Frame%201000009369.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774321998169/Frame%201000009369.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1757756429435-cqlafb-compressed-%E8%8A%AF%E7%89%87.jpg',
            h5: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774248717123/36.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774248296691/1.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1757758983900-qjhq90-compressed-%E8%8A%AF%E7%89%87-1%E5%BA%A6%E7%94%B5.jpg',
        },
        {
            title: t('list2_title'),
            desc: t.rich('list2_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774406854312/image.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774420023129/image%20(2)%20(1).jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1758710600121-j0jtp6-compressed-image.jpg',
            pad: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774406854312/image.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774420023129/image%20(2)%20(1).jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1758710600121-j0jtp6-compressed-image.jpg',
            h5: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774406853747/35.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774420117625/2.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1758710662948-m5jxpq-compressed-2.jpg',
        },
        {
            title: t('list3_title'),
            desc: t.rich('list3_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774406854081/image%20(1).jpg" : "https://websiteoss.ecoflow.com/upload/image/1773904720626/333.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1758710629108-18wg83-compressed-%E9%A3%8E%E6%9A%B4.jpg',
            pad: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774406854081/image%20(1).jpg" : "https://websiteoss.ecoflow.com/upload/image/1773904720626/333.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1758710629108-18wg83-compressed-%E9%A3%8E%E6%9A%B4.jpg',
            h5: isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1774406853606/34.jpg" : "https://websiteoss.ecoflow.com/upload/image/1774248297025/3.jpg") : 'https://websiteoss.ecoflow.com/figma-uploads/1758710681517-2pwkwv-compressed-3.jpg',
        },
        {
            title: t.rich('list4_title', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t.rich('list4_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: isEu || locale === 'uk' ? imgs[locale] : 'https://websiteoss.ecoflow.com/figma-uploads/1758879515108-yh3efr-compressed-image.jpg',
            pad: isEu || locale === 'uk' ? imgs[locale] : 'https://websiteoss.ecoflow.com/figma-uploads/1758879541815-bhhlb1-compressed-4.jpg',
            h5: isEu || locale === 'uk' ? imgsH5[locale] : 'https://websiteoss.ecoflow.com/figma-uploads/1758879541815-bhhlb1-compressed-4.jpg',
        },
    ];

    const handlePrev = (name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title'),
            button_name: name,
        });
    };

    const handleNext = (name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title'),
            button_name: name,
        });
    };

    return (
        <div className={`${styles.Built} GtmModuleData-section`} data-section-id="d3c-Built" id="Built">
            <EcoSpace />
            <AnimatedGrid variant="fadeInUp" options={{ delay: 200, stagger: 0.2 }} className="d3m-title-common">
                <EcoSectionCommon className="d3m-title-common d3m-layout" title={t('title')} desc={t('desc')} />
                <div className="swiper-built d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={'auto'}
                        spaceBetween={24}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        initialSlide={0}
                    >
                        {list.map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="list-item">
                                    <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy={true} />

                                    <div className="text-wrapper">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                        <div className="swiper-button-prev" onClick={() => handlePrev('Left switch')} />
                        <div className="swiper-button-next" onClick={() => handleNext('Right switch')} />
                    </Swiper>
                </div>
            </AnimatedGrid>

            <EcoSpace />
        </div>
    );
};

export default Built;
